import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const markProjectBridgeRecommendationsApplied = api(async function markProjectBridgeRecommendationsApplied({
    projectId,
    scheduleId,
    importId,
    targets,
    applied,
}) {
    return mutate(
        gql`
            mutation MarkProjectBridgeRecommendationsApplied(
                $projectId: String!
                $scheduleId: String!
                $importId: String!
                $targets: [JSON!]!
                $applied: Boolean
            ) {
                markProjectBridgeRecommendationsApplied(
                    projectId: $projectId
                    scheduleId: $scheduleId
                    importId: $importId
                    targets: $targets
                    applied: $applied
                )
            }
        `,
        { projectId, scheduleId, importId, targets, applied },
        { returns: "markProjectBridgeRecommendationsApplied" }
    )
})
